import { ActionIcon } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import type { Row } from '@tanstack/react-table';
import type { TableRow } from 'app/Private/Clients/Detail/BalanceTab/BalanceTable/types/table-row-types';
import type { BalanceRowType } from 'types/balance-row-type';
import { CreditNoteLabel, InvoiceLabel, PaymentLabel } from '../component';

type ExpandedRowProps = {
  row: Row<TableRow>;
  onToggle: (rowId: string) => void;
};

export const ExpandedRow = ({ row, onToggle }: ExpandedRowProps) => {
  const handleClick = () => {
    onToggle(row.id);
    row.getToggleExpandedHandler()();
  };

  return (
    <ActionIcon variant="transparent" onClick={handleClick} style={{ cursor: 'pointer' }}>
      <IconChevronRight
        style={{ transform: row.getIsExpanded() ? 'rotate(90deg)' : 'rotate(0deg)' }}
        size={18}
      />
    </ActionIcon>
  );
};

export const getTypeCellLabel = (type: BalanceRowType) => {
  switch (type) {
    case 'invoice':
      return <InvoiceLabel />;
    case 'credit_note':
      return <CreditNoteLabel />;
    case 'payment':
      return <PaymentLabel />;
    default:
      return null;
  }
};
